import PouchLoadService from "external-services/pouch-load-service/index";

/**
 * Has dependency on floorplan-bundle.js
 */

const NS = 'PlanDoorService';

export default function PlanDoorService(SnapConst, SnapService, PlanConst, Group, Structure) {
  "ngInject";

  function Door(s, mode, model) {

    var defaults = {
      _id: PouchLoadService.getNewId(['structure']),
      type: Structure.Type,
      subType: Structure.SubTypes.DoorLeft,
      width: 80,
      height: 80,
      rotation: 0,
      position: {
        x: 0,
        y: 0
      }
    };

    if (model && model.subType === Structure.SubTypes.DoorDouble) {
      defaults.width = 160;
    }

    this.s = s;
    this.mode = mode;
    this.model = _.extend({}, defaults, model);
    this.resizable = this.model.subType === Structure.SubTypes.DoorDouble ? _.clone(Door.Resizable.Double) : _.clone(Door.Resizable.Single);
    this.actions = _.clone(Door.Actions);

    this.shape = {
      w: this.model.width,
      h: this.model.height
    };

    this.render();
    this.refresh();
    this.rotate(this.model.rotation);
    this.place(this.model.position);
  }

  Door.prototype = _.extend({}, new Structure(), {
    render: function () {
      var box = this.getVisualBox();

      this.element = new Group(this.s, 'Door', {
        type: SnapConst.Shapes.Rect,
        w: box.w,
        h: box.h
      });
      this.element.buildRootElement();
      SnapService.getElement(this.element).addClass('structure door ' + this.model.subType).data()._id = this.model._id;
      //Body
      this.line = this.s.rect(0, 0, 1, 80).addClass('line');
      this.element.addElement(this.line, 'line');
      if (this.model.subType === Structure.SubTypes.DoorRight) {
        SnapService.place(this.line, 79, 0);
      } else {
        SnapService.place(this.line, 0, 0);
      }
      //Curve
      if (this.model.subType === Structure.SubTypes.DoorRight) {
        this.curve = this.s.path('M80,0.5 C40,0 0,40 0.5,80').addClass('curve');
      } else {
        this.curve = this.s.path('M0.5,0.5 C40,0 80,40 79.5,80').addClass('curve');
      }
      this.element.addElement(this.curve, 'curve');
      SnapService.place(this.curve, 0, 0);
      if (this.model.subType === Structure.SubTypes.DoorDouble) {
        this.line2 = this.s.rect(0, 0, 1, 80).addClass('line');
        this.element.addElement(this.line2, 'line2');
        SnapService.place(this.line, 159, 0);
        this.curve2 = this.s.path('M159,0.5 C119.5,1 80,39 80.5,80').addClass('curve');
        this.element.addElement(this.curve2, 'curve2');
        SnapService.place(this.curve2, 0, 0);
      }
    },

    refresh: function (anchor) {
      var info = this.beforeResize(anchor);

      this.element.shape.w = this.model.width;
      this.element.shape.h = this.model.height;
      this.shape = this.element.shape;

      this.line.attr({
        height: this.model.height
      });
      if (this.model.subType === Structure.SubTypes.DoorRight) {
        SnapService.place(this.line, this.model.width - 1, 0);
      }
      if (this.model.subType === Structure.SubTypes.DoorRight) {
        this.curve.attr({
          d: 'M' + this.model.width + ',0.5 C' + this.model.width / 2 + ',0 0,' + this.model.height / 2 + ' 0.5,' + this.model.height
        });
      } else {
        this.curve.attr({
          d: 'M0.5,0.5 C' + this.model.width / 2 + ',0 ' + this.model.width + ',' + this.model.height / 2 + ' ' + (this.model.width - 0.5) + ',' + this.model.height
        });
      }
      if (this.model.subType === Structure.SubTypes.DoorDouble) {
        this.curve.attr({
          d: 'M0.5,0.5 C' + this.model.width / 4 + ',0 ' + this.model.width / 2 + ',' + this.model.height / 2 + ' ' + (this.model.width / 2 - 0.5) + ',' + this.model.height
        });
        this.line2.attr({
          height: this.model.height
        });
        SnapService.place(this.line2, this.model.width - 1, 0);
        SnapService.place(this.line, 0, 0);
        this.curve2.attr({
          d: 'M' + (this.model.width - 1) + ',0.5 C' + ((this.model.width * 0.75) - 0.5) + ',1 ' + this.model.width / 2 + ',' + ((this.model.height / 2) - 1) + ' ' + (this.model.width / 2 + 0.5) + ',' + this.model.height
        });
        SnapService.place(this.curve2, 0, 0);
      }

      this.afterResize(info);
    },

    getVisualBox: function () {
      return {
        x: 0,
        y: 0,
        w: this.model.width,
        h: this.model.height
      };
    }
  });

  /************************************************************************************************************************
   *************************************************************************************************************************
   STATIC ATTRIBUTES AND FUNCTIONS
   *************************************************************************************************************************
   ************************************************************************************************************************/

  Door.Resizable = {
    Single: {
      hStep: 20,
      hMin: 20,
      hMax: -1,
      wStep: 20,
      wMin: 20,
      wMax: -1
    },
    Double: {
      hStep: 20,
      hMin: 20,
      hMax: -1,
      wStep: 20,
      wMin: 40,
      wMax: -1
    }
  };

  Door.Actions = {
    spread: true,
    rotate: true,
    edit: true
  };

  Door.buildToolbarElement = function (s, type) {
    var door = {};
    door.g = new Group(s, 'Door', {
      type: SnapConst.Shapes.Rect,
      w: type === Structure.SubTypes.DoorDouble ? 80 : 40,
      h: 60
    });
    door.g.buildRootElement();
    door.g.getSGroup().data('type', type);
    door.g.getSGroup().addClass('structure door');
    door.line = s.rect(0, 0, 1, 40).addClass('line');
    door.g.addElement(door.line, 'line');
    if (type === Structure.SubTypes.DoorRight) {
      SnapService.place(door.line, 39, 0);
    } else {
      SnapService.place(door.line, 0, 0);
    }
    if (type === Structure.SubTypes.DoorRight) {
      door.curve = s.path('M40,0 C20,0 0,20 0,40').addClass('curve');
    } else {
      door.curve = s.path('M0,0 C20,0 40,20 40,40').addClass('curve');
    }
    door.g.addElement(door.curve, 'curve');
    SnapService.place(door.curve, 0, 0);
    if (type === Structure.SubTypes.DoorDouble) {
      door.line2 = s.rect(0, 0, 1, 40).addClass('line');
      door.g.addElement(door.line2, 'line2');
      SnapService.place(door.line, 79, 0);
      door.curve2 = s.path('M80,0 C60,0 40,20 40,40').addClass('curve');
      door.g.addElement(door.curve2, 'curve2');
      SnapService.place(door.curve2, 0, 0);
    }
    door.label = s.text(0, 0, Structure.getTypeName(type)).addClass('label');
    door.g.addElement(door.label, 'label');
    SnapService.place(door.label, (type === Structure.SubTypes.DoorDouble ? 80 : 40) / 2, 50);
    return door.g;
  };

  return Door;
}
